import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import useStickyTracking from '../../../../shared/utils/hooks/sticky';
import NavigationBar from '../../../../shared/library/navigation-bar';
import {FOCUS_BLUE, GUNSMOKE} from '../../../../shared/style/colors';
import DescriptionIcon from '../../../../shared/library/icons/nav/description.svg';
import KeywordIcon from '../../../../shared/library/icons/keywords-icon.svg';
import DescriptionAltIcon from '../../../../shared/library/icons/nav/description-alt.svg';
import StatsIcon from '../../../../shared/library/icons/nav/stats.svg';
import ProsIcon from '../../../../shared/library/icons/nav/pros.svg';
import AlternativesIcon from '../../../../shared/library/icons/nav/alternatives.svg';
import IntegrationsIcon from '../../../../shared/library/icons/nav/integrations.svg';
import BlogsIcon from '../../../../shared/library/icons/nav/blog.svg';
import Jobs from '../../../../shared/library/icons/nav/jobs.svg';
import StacksIcon from '../../../../shared/library/icons/nav/stack.svg';
import FollowersIcon from '../../../../shared/library/icons/nav/followers.svg';
import CtaPanel from '../../../../shared/library/cta-panel';
import glamorous from 'glamorous';
import withErrorBoundary from '../../../../shared/enhancers/error-boundary';

const defaultActiveStyles = {
  color: FOCUS_BLUE,
  borderColor: FOCUS_BLUE
};

const activeStyles = {
  ...defaultActiveStyles,
  ' svg path': {
    fill: FOCUS_BLUE,
    stroke: FOCUS_BLUE
  }
};

const JobsIcon = glamorous(Jobs)({
  width: 20,
  height: 20,
  ' path': {
    fill: GUNSMOKE
  }
});

const Nav = ({
  service,
  showIntegrations,
  showStacks,
  showFollowers,
  showStats,
  showJobs,
  showKeywords,
  showAlternatives,
  jobsCount,
  showPros = true,
  privateMode,
  showPosts,
  currentUser
}) => {
  const showFeatures = !!service.features;
  const stickyRef = useRef(null);
  const isStuck = useStickyTracking(stickyRef);
  const allMenuOptions = [
    {
      name: 'Description',
      icon: <DescriptionAltIcon />,
      slug: 'description',
      activeStyles,
      visible: true
    },
    {
      name: 'Keywords',
      icon: <KeywordIcon />,
      slug: 'keywords',
      activeStyles,
      visible: showKeywords
    },
    {name: 'Stacks', icon: <StacksIcon />, slug: 'stacks', activeStyles, visible: showStacks},
    {
      name: 'Integrations',
      icon: <IntegrationsIcon />,
      slug: 'integrations',
      activeStyles,
      visible: showIntegrations
    },
    {name: 'Pros', icon: <ProsIcon />, slug: 'pros', activeStyles, visible: showPros},
    {
      name: 'Blog Posts',
      icon: <BlogsIcon />,
      slug: 'posts',
      activeStyles,
      visible: showPosts
    },
    {
      name: 'Jobs',
      icon: <JobsIcon />,
      slug: 'jobs',
      activeStyles,
      visible: showJobs,
      count: jobsCount
    },
    {
      name: 'Features',
      icon: <DescriptionIcon />,
      slug: 'features',
      activeStyles,
      visible: showFeatures
    },
    {
      name: 'Alternatives',
      icon: <AlternativesIcon />,
      slug: 'alternatives',
      activeStyles,
      visible: showAlternatives
    },
    {name: 'Stats', icon: <StatsIcon />, slug: 'stats', activeStyles, visible: showStats},
    {
      name: 'Followers',
      icon: <FollowersIcon />,
      slug: 'followers',
      activeStyles,
      visible: showFollowers
    }
  ];

  const visibleMenuItems = allMenuOptions
    .filter(item => {
      return item.visible === true;
    })
    .map(item => {
      return item;
    });
  return (
    <NavigationBar items={visibleMenuItems} ref={stickyRef} itemWidth={82} onItemClick={() => null}>
      <CtaPanel
        service={service}
        isStuck={isStuck}
        privateMode={privateMode}
        currentUser={currentUser}
      />
    </NavigationBar>
  );
};

Nav.propTypes = {
  service: PropTypes.object,
  showIntegrations: PropTypes.bool,
  showStacks: PropTypes.bool,
  showKeywords: PropTypes.bool,
  showAlternatives: PropTypes.bool,
  showFollowers: PropTypes.bool,
  showStats: PropTypes.bool,
  showJobs: PropTypes.bool,
  showPros: PropTypes.bool,
  showPosts: PropTypes.bool,
  jobsCount: PropTypes.number,
  privateMode: PropTypes.any,
  currentUser: PropTypes.object
};

export default withErrorBoundary(true)(Nav);
